<div class="form-floating relative">
    <input [type]="type" class="form-control" id="floatingPassword" placeholder="Ingrese contraseña..."
        [autocomplete]="!onlyPass ? 'new-password' : 'on'" [ngClass]="{ 'error': error }" [(ngModel)]="value"
        (ngModelChange)="isValidString($event)" />
    <label for="floatingPassword" class="floatlabel" [ngClass]="{ 'text-danger': error }">{{ label }}</label>
    <i class="pi {{ icon }} absolute" (click)="togglePass()"></i>
</div>
<ng-container *ngIf="!onlyPass">
    <div style="display: flex; justify-content: start; flex-direction: column;">
        <p class="m-0 text-start pl-2" [ngClass]="{ 'text-danger': !hasUpperCase, 'text-success': hasUpperCase }">
            <small>
                <i class="pi pr-1" style="font-size: .7rem;"
                    [ngClass]="{ 'pi-check': hasUpperCase, 'pi-times-circle': !hasUpperCase }">
                </i><b>Debe contener 1 letra mayúscula</b></small>
        </p>
        <p class="m-0 text-start pl-2" [ngClass]="{ 'text-danger': !hasSpecialChar, 'text-success': hasSpecialChar }">
            <small>
                <i class="pi pr-1" style="font-size: .7rem;"
                    [ngClass]="{ 'pi-check':  hasSpecialChar, 'pi-times-circle': ! hasSpecialChar }">
                </i><b>Debe contener al menos 1 carácter especial</b></small>
        </p>
        <p class="text-start m-0 p-0 pl-2" [ngClass]="{ 'text-danger': !isLength, 'text-success': isLength }">
            <small>
                <i class="pi pr-1" style="font-size: .7rem;"
                    [ngClass]="{ 'pi-check': isLength, 'pi-times-circle': !isLength }">
                </i><b>8 caracteres como mínimo</b></small>
        </p>
        <p class="text-start m-0 p-0 pl-2" [ngClass]="{ 'text-danger': !hasNumbers, 'text-success': hasNumbers }">
            <small><i class="pi pr-1" style="font-size: .7rem;"
                    [ngClass]="{ 'pi-check': hasNumbers, 'pi-times-circle': !hasNumbers }">
                </i><b>4 números como mínimo</b></small>
        </p>
        <p class="text-start m-0 p-0 pl-2"
            [ngClass]="{ 'text-danger': !nonConsecutive || !nonRepetitive, 'text-success': nonConsecutive && nonRepetitive }">
            <small><i class="pi pr-1" style="font-size: .7rem;"
                    [ngClass]="{ 'pi-check': nonConsecutive && nonRepetitive, 'pi-times-circle': !nonConsecutive || !nonRepetitive }">
                </i><b>Números no consecutivos (e.j. 1234 ó 4321) ni repetitivos (e.j. 1111)</b></small>
        </p>
    </div>
</ng-container>